import React,{useEffect,useState} from "react";
import yes from "./yes.png";
import { useTranslation } from "react-i18next";
import { onecodeAPI } from "../AppConfig";
import { Modal, Spin } from "antd";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import {
  CloseOutlined,
  WhatsAppOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "antd/es/spin/style/css";

let lmsRefreshIntervalId = null;
export default function Eligilble({ applyToPartner , customer , selectedPartnerStatus,customerDetails}) {
  let partnerDetails = JSON.parse(sessionStorage.getItem("partnerDetails"));
  const {t} = useTranslation();
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [emailHandlePopup, setEmailHandlePopup] = useState(false);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);


  const handleEligiblePopupCancel = () => {
    setIsEligibleModalVisible(false);
  };

  const hideEmailHandlePopup = () => {
    setEmailHandlePopup(false);
  };



  const onLMSBrandsClick = async () => {
    let hash = encodeURIComponent(searchParams.get("hash"));
    try {
      const res = await onecodeAPI.post(`/public/customer/verifyApi?`, {
        hash: hash,
        partnerId: partnerDetails?.id,
      });
      if (res.data?.data?.url) {
        window.open(res.data?.data?.url, "_blank");
      }
    } catch (error) {
      console.log(error, "error---");
    }
  };

  
  return (
    <div
      className="eligible"
      onClick={() => {
        window?.Moengage?.track_event("mycustomers-brand_customer_getlink",{
          language:"en",
          brand_name:partnerDetails?.name,
          brand_category:partnerDetails?.subCategory,
          customer_name:customer?.fullName,
          customer_phonenumber:customer?.phoneNumber,
        });

          applyToPartner();
      }}
    >
      <div className="eligibleDetails">
        <div className="eligibleLogo">
          <img
            alt=""
            src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/LOGOS_PNG/${partnerDetails?.id}.png`}
          />
        </div>

        <div className="eligibleReason">
          {selectedPartnerStatus==="leadadded"?<h3>{t("recommendation.great")}</h3>:selectedPartnerStatus==="success"?<h3>{t("recommendation.hey")}</h3>:selectedPartnerStatus==="rejected"?<h3>{t("recommendation.oops")}</h3>:<></>}

          {selectedPartnerStatus==="leadadded"?<p>{t("recommendation.weesee")}{" "}<span style={{fontWeight:"700"}}> {partnerDetails?.title}.</span></p>:selectedPartnerStatus==="success"?<p>{t("recommendation.seems")}{" "}<span style={{fontWeight:"700"}}> {partnerDetails?.title}.</span>{t("recommendation.tryanother")}</p>:selectedPartnerStatus==="rejected"?<p>{t("recommendation.alreadyapplied")}{" "}<span style={{fontWeight:"700"}}> {partnerDetails?.title}.</span>{t("recommendation.pleaseTry")}</p>:<></>}

        </div>
        {selectedPartnerStatus==="leadadded"?<div className="getLinkBtn">{t("recommendation.getlink")}</div>:<></>}
      </div>

      {isEligibleModalVisible && (
          <Modal
            visible={isEligibleModalVisible}
            onCancel={handleEligiblePopupCancel}
            footer={null}
            centered={true}
            closable={true}
            bodyStyle={{
              border: "1px solid  #fff",
              justifySelf: "center",
              borderRadius: "10px",
              padding: "20px",
            }}
            width="90%"
            closeIcon={<CloseOutlined className="modalCloseBtn" />}
          >
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
                fontWeight: "bold",
              }}
            >
              Not Eligible
            </p>
            {brandNotEligibleReasons?.map((item, key) => (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                  color: "#7D7D7D",
                }}
              >
                {key + 1}. {item}
              </p>
            ))}
          </Modal>
        )}
        {emailHandlePopup && (
        <Modal
          visible={emailHandlePopup}
          onCancel={hideEmailHandlePopup}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Invalid Email ID!
          </p>
          
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              Email already exists OR invalid characters/length/domain in Email, please ask your Business Consultant to update the email ID and apply again.
            </p>
            <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                hideEmailHandlePopup();
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Ok, got it.
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
